const config = {
    apiBase: '/api',
    productionTip: false,
}

export default config;